import React, { useEffect, Fragment, useState } from "react";
import { getStores } from '../services';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Leftnav from '../components/Leftnav';
import Pagetitle from '../components/Pagetitle';
import Appfooter from '../components/Appfooter';

const Storie = () => {
    const [stores, setStores] = useState([]);
    const fetch = async () => {
        const theStores = await getStores();
        setStores(theStores.data)
    }
    useEffect(() => {
        fetch();
    },[])
        return (
            <Fragment> 
                <Header />
                <Leftnav />
                <div className="main-content right-chat-active">
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left pe-0">
                            <div className="row">
                                <div className="col-xl-12">
                                    <Pagetitle title="Enterate..."/>
                                    <div className="row ps-2 pe-1">
                                        {stores.map((value , index) => (
                                        <Link to={`/grouppage?id=${value._id}`} key={index} className="col-md-3 col-xss-6 pe-2 ps-2">
                                            <div className="card h300 d-block border-0 shadow-xss rounded-3 bg-gradiant-bottom overflow-hidden mb-3 bg-image-cover" style={{backgroundImage: `url("${value.banner ? value.banner.url : 'https://logos-marcas.com/wp-content/uploads/2020/04/Huawei-Logo.png'}")`}}>
                                                <div className="card-body d-block w-100 position-absolute bottom-0 text-center">
                                                    <figure className="avatar ms-auto me-auto mb-0 position-relative w50 z-index-1"><img src={`${value.banner ? value.banner.url : 'https://logos-marcas.com/wp-content/uploads/2020/04/Huawei-Logo.png'}`} alt="avater" className="float-right p-0 bg-white rounded-circle w-100 shadow-xss" /></figure>
                                                    <div className="clearfix"></div>
                                                    <h4 className="fw-600 position-relative z-index-1 ls-3 font-xssss text-white mt-2 mb-1">{value.firstName}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                        ))}
                                    </div>
                                </div>               
                            </div>
                        </div>
                        
                    </div>
                </div>
                <Appfooter /> 
            </Fragment>
        );
}

export default Storie;